import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          <p className="text-sm text-muted-foreground">Caricamento...</p>
        </div>
      </div>
    );
  }
  if (user === null) {
    const loginPath = roles && roles.includes('customer') ? '/cliente/accedi'
      : roles && roles.includes('investor') ? '/investitori/accedi'
      : '/login';
    return <Navigate to={loginPath} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    const home = user.role === 'admin' ? '/admin'
      : user.role === 'staff' ? '/staff-area'
      : user.role === 'customer' ? '/cliente'
      : user.role === 'investor' ? '/investitori'
      : '/area';
    return <Navigate to={home} replace />;
  }
  return children;
}
